import React, { useState } from 'react';
import PageWrapper from '../../components/ui/layout/PageWrapper';
import Panel from '../../components/ui/panel/Panel';
import Text from '../../components/ui/text/Text';
import { Row, Col } from 'react-grid-system';
import Input from '../../components/ui/input/Input';
import Button from '../../components/ui/button/Button';
import FormGroup from '../../components/ui/form-group/FormGroup';
import FormLabel from '../../components/ui/form-label/FormLabel';
import { connect } from 'react-redux';
import { AppState } from '../..';
import counterpart from 'counterpart';
import { grpcUnaryCall } from '../../utils/grpc/grpcUtils';
import { ConfigConstants } from '../../utils/config';
import { GetSpreedlyTransactionRequest, GetSpreedlyTransactionResponse } from '../../utils/grpc/generated/Billsby.Protos/billing/private/paymentgateway/payment_gateway_pb';
import { PaymentGatewayServiceClient } from '../../utils/grpc/generated/Billsby.Protos/billing/private/paymentgateway/Payment_gatewayServiceClientPb';
import NoticePanel from '../../components/ui/notice-panel/NoticePanel';

interface ISpreedlyPaymentLogs {
}

const SpreedlyPaymentLogs: React.FC<ISpreedlyPaymentLogs> = () => {
  const [reference, setReference] = useState("");
  const [paymentLog, setPaymentLog] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");


  const onSubmit = (evt: any) => {
    evt.preventDefault();
    setIsLoading(true);
    setError("");
    setPaymentLog("");
    const getSpreedlyTransactionRequest = new GetSpreedlyTransactionRequest();
    getSpreedlyTransactionRequest.setCompanyDomain("");
    getSpreedlyTransactionRequest.setTransactionToken(reference)
    const paymentGatewayServiceClient = new PaymentGatewayServiceClient(ConfigConstants.grpcBaseUrl);
    grpcUnaryCall(getSpreedlyTransactionRequest, paymentGatewayServiceClient, paymentGatewayServiceClient.getSpreedlyTransaction)
    .then((response) => {
      const data = response as GetSpreedlyTransactionResponse;
      setPaymentLog(JSON.stringify(data.toObject(), null, 2))
      setIsLoading(false);
    }, err => {
      setError(err?.message);
      setIsLoading(false);
    });
  }

  return (
    <PageWrapper>
      <form onSubmit={onSubmit}>
        <Panel title="SPREEDLY_PAYMENT_LOGS">
          <Text content="SPREEDLY_PAYMENT_LOGS_CONTENT" noMargin />
        </Panel>
        {
          (!!error && !isLoading)
          && <NoticePanel
            type="error"
            icon="far fa-exclamation-circle"
            content={error || counterpart("SPREEDLY_PAYMENT_LOGS_ERROR")}
            shouldTranslate={false}
          />
        }

        <Panel title="SPREEDLY_PAYMENT_LOGS_FORM">

          <FormGroup>
            <Row align="center">
              <Col xs={2}>
                <FormLabel target="reference-number" content="SPREEDLY_PAYMENT_LOGS_REFERENCE" noMargin />
              </Col>
              <Col xs={10}>
                <Input
                  id="reference-number"
                  placeholder={counterpart("SPREEDLY_PAYMENT_LOGS_REFERENCE_PLACEHOLDER")}
                  value={reference}
                  onChange={(evt: any) => setReference(evt.target.value)}
                  required
                />
              </Col>
            </Row>
          </FormGroup>

          <Button
            id="spreedly-payment-log-view-button"
            title="SPREEDLY_PAYMENT_LOGS_VIEW_BUTTON"
            type="submit"
            disabled={!reference || isLoading}
            isLoading={isLoading}
            isFullWidth
          />
        </Panel>
      </form>
      {
        !!paymentLog &&
        <Panel>
          <pre>{paymentLog}</pre>
        </Panel>
      }
    </PageWrapper>
  )
}

export default connect((state: AppState) => ({ intercomReducer: state.intercom }))(SpreedlyPaymentLogs);